/* unplugin-vue-components disabled */import { render } from "./impersonation-bar.vue?vue&type=template&id=3c0fc387"
import script from "./impersonation-bar.vue?vue&type=script&lang=js"
export * from "./impersonation-bar.vue?vue&type=script&lang=js"

import "./impersonation-bar.vue?vue&type=style&index=0&id=3c0fc387&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__